module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h3', [_c('strong', [_vm._v("Informações do evento: " + _vm._s(_vm.event.name) + " ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('b', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Data:")]), _vm._v(" " + _vm._s(this.start_date.getDate()) + " a " + _vm._s(this.end_date.getDate()) + " de " + _vm._s(this.month_event)), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Horário:")]), _vm._v(" " + _vm._s(this.start_date.getHours()) + "hs as " + _vm._s(this.end_date.getHours()) + "hs"), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Local:")]), _vm._v(" " + _vm._s(_vm.event.address)), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("LEIA AS INFORMAÇÕES ABAIXO:")]), _c('br')]), _c('p', {
    attrs: {
      "id": "info"
    }
  }), _c('br'), _vm._v(" "), _c('p')])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65960137!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/About.vue
// module id = 100
// module chunks = 2